import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Login from "features/auth/pages/Login";
import Report from "features/report/pages/Report";
import Teacher from "features/teacher/pages/Teacher";
import ClassAnalytics from "features/analytics/pages/ClassAnalytics";
import ContactUs from "features/contact/pages/ContactUs";
import Parents from "features/parents/pages/Parents";
import FinanceDashboard from "features/invoice-tracker/pages/FinanceDashboard";
import Adminhome from "features/admin/pages/Adminhome";

// Auth guard
import RequireAuth from "app/router";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Login />} />
          <Route path="/contact" element={<ContactUs />} />

          {/* Authenticated (any logged-in user) */}
          <Route element={<RequireAuth />}>
            <Route path="/report" element={<Report />} />
            <Route path="/hasil_asesmen" element={<Parents />} />
          </Route>

          {/* Teacher / Principal */}
          <Route element={<RequireAuth roles={["teacher", "principal"]} />}>
            <Route path="/teacher" element={<Teacher />} />
            <Route path="/teacher/class/:id" element={<ClassAnalytics />} />
          </Route>

          {/* Admin-only */}
          <Route element={<RequireAuth roles={["admin"]} />}>
            <Route path="/admin" element={<Adminhome />} />
          </Route>

          {/* Finance Admin only */}
          <Route element={<RequireAuth roles={["financeAdmin"]} />}>
            <Route path="/finance" element={<FinanceDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>

          <ToastContainer
        position="top-right"
        autoClose={2500}
        newestOnTop
        style={{ zIndex: 999999 }}
      />


      <ToastContainer
        containerId="confirm"
        position="top-center"  
        autoClose={false}
        closeOnClick={false}
        draggable={false}
        hideProgressBar
        newestOnTop
        style={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "auto",
          zIndex: 999999,       
        }}
      />
    </>
  );
}
